module.exports = __webpack_public_path__ + "media/images/ww1000-640ae167d41e1223b41faf053a7c3b09.svg";